import { useEffect, useRef, useState } from 'react';

// `text` is a dependency because content growing inside a fixed-width box resizes
// nothing, so the ResizeObserver alone never fires.
export const useTextOverflow = <T extends HTMLElement>(text?: string) => {
  const ref = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const element = ref.current;

    if (!element) {
      return;
    }

    // An ellipsised descendant clips inside a box that itself still fits.
    const measure = () =>
      setIsOverflowing(
        [element, ...element.querySelectorAll('*')].some(
          (node) =>
            node instanceof HTMLElement && node.scrollWidth > node.clientWidth,
        ),
      );

    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(element);

    return () => observer.disconnect();
  }, [text]);

  return { ref, isOverflowing };
};
